import gql from "graphql-tag";

export const SEND_INVOICE = gql`
  mutation ($input: sendInvoiceInput) {
    sendInvoice(input: $input)
  }
`;
